import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function fetchCategories(): Promise<any> {
  try {
    const response = await axiosInstance.get(`${config.apiUrl}/categories`);
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error fetching Categories"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
